import { StatusPill } from '@vnetwork/ui/data';
import { channelStatusTone, channelStatusLabel } from './shared';

/** Channel enabled/disabled state. @mgmt owns the channel config + status flag. */
export function ChannelStatusPill({ status }: { status?: string }) {
  return <StatusPill tone={channelStatusTone(status)}>{channelStatusLabel(status)}</StatusPill>;
}
